import apiClient from './apiClient';
import type { AuthUser } from '../stores/authStore';

// AI model option as served by GET /api/v1/ai/models. The list is DB-driven —
// never hardcode model ids in the UI.
export interface AiModel {
  id: string;
  label?: string;
  provider?: string;
  description?: string;
}

// TTS voice option from GET /api/v1/tts/voices (e.g. Chirp3-HD voices).
export interface TtsVoice {
  id: string;
  label?: string;
  language?: string;
  gender?: string;
}

export interface UserSettings {
  preferred_voice?: string | null;
  preferred_theme?: 'paper' | 'light' | 'dark' | null;
  preferred_ai_model?: string | null;
}

export async function listAiModels(): Promise<AiModel[]> {
  const { data } = await apiClient.get<AiModel[]>('/api/v1/ai/models');
  return data;
}

export async function listVoices(): Promise<TtsVoice[]> {
  const { data } = await apiClient.get<TtsVoice[]>('/api/v1/tts/voices');
  return data;
}

// Persist preferences. Backend exposes PUT /api/v1/me; returns the updated user.
export async function saveSettings(settings: UserSettings): Promise<AuthUser> {
  const { data } = await apiClient.put<AuthUser>('/api/v1/me', settings);
  return data;
}
